import { Outlet } from 'react-router-dom';
import MainHeader from './header';
import { Button, Card, CardContent, Divider, IconButton, Input, TextField, Typography, Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { get, post } from 'api/apiBridges/httpBridge';
import { useSelector } from 'react-redux';
import { loginSelector } from 'store/slices/loginSlice';
import { Email, Visibility, VisibilityOff } from '@mui/icons-material';
import Loading from 'components/Load';
import { colors } from 'styles/colors';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import wb from '../images/markets/wb.png';
import ozone from '../images/markets/ozon.png';


const ClientAPISettings = () => {

  const { user_id} = useSelector(
      loginSelector
  );

  const [loading, setLoading] = useState(true);
  const [changed, setChanged] = useState(false);
  const [user, setUser] = useState({
      api_key:'',
      api_key_ozon:'',
      api_cli_ozon:''
  })

  const [loadingWB, setLoadingWB] = useState(true);
  const [loadingOZON, setLoadingOZON] = useState(true);
  const [WBCheck, setWBCheck] = useState([]);
  const [OZONCheck, setOZONCheck] = useState([]);

  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOzon, setShowPasswordOzon] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleClickShowPasswordOzon = () => setShowPasswordOzon((show) => !show);

  const handleMouseDownPasswordOzon = (event) => {
    event.preventDefault();
  };

  const consCheckWBAPI = async () => {
      try {
        setLoadingWB(true);
        let res = await get('WBAPI/checkApiAccess', {uid: user_id})
        setWBCheck(Array.isArray(res) ? res : [])

      } catch (err) {
      } finally {
        setLoadingWB(false);
      }
  };

  const consCheckOZONAPI = async () => {
      try {
        setLoadingOZON(true);
        let res = await get('OZONAPI/checkApiAccess', {uid: user_id})
        console.log('OZON CHECK RES', res)
        setOZONCheck(Array.isArray(res) ? res : []);

      } catch (err) {
      } finally {
        setLoadingOZON(false);
      }
  };

  useEffect(() => {
    const fetchData = async () => {
        try {
          setLoading(false);
          const responseData = await get('Clients/get', {cid:user_id});
          if (responseData?.message) {
              let obj = {
                  api_key:responseData.message.api_key|| "",
                  api_key_ozon:responseData.message.api_key_ozon|| "",
                  api_cli_ozon:responseData.message.api_cli_ozon|| "",
              }
              setUser(obj)
          }
        } catch (err) {
        } finally {
          setLoading(false);
        }
    };

    fetchData();
    consCheckWBAPI()
    consCheckOZONAPI()
  }, []); 

  const change = (path, val) => {
    let tmp = {...user}
    tmp[path] = val
    setUser(tmp)
    setChanged(true)
  }

  const save = async () => {
    await post('Clients/addupdate', {id:user_id, api_key:user.api_key, api_key_ozon:user.api_key_ozon, api_cli_ozon:user.api_cli_ozon})
    setChanged(false)
    consCheckWBAPI()
    consCheckOZONAPI()
  }

  if (loading) {
      return <Loading></Loading>
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        alignItems: "center",
        height: "90%",
        overflowY: "auto",
        overflowX: "hidden",
        paddingRight: "10px",
      }}
    >
      {/* WB */}

      <Box sx={{ width: "100%", padding: "15px", marginTop:'30px' ,}}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography sx={{ fontSize: "18pt", color: "#838383" }}>
            Ключ API WB:
          </Typography>
          <img src={wb} style={{ width: 55, height: 55 }} />
        </Box>

        <TextField
          style={{ width: "100%", marginTop: "10px" }}
          value={user.api_key || ""}
          placeholder={!user.api_key ? "Не указано" : ""}
          onChange={(event) => change("api_key", event.target.value)}
          type={showPassword ? "text" : "password"}
          inputProps={{ autoComplete: "new-password" }} 
          InputProps={{
            endAdornment: (
              <IconButton
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            ),
          }}
        />

        <Box sx={{ marginTop: "15px" }}>
          {loadingWB ? (
            <Loading />
          ) : (
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "8px 20px",
              }}
            >
              {WBCheck.map((el, i) => (
                <Box key={i} display="flex" alignItems="center">
                  <CheckCircleOutlineIcon
                    sx={{
                      color: el.active ? "#208f84" : "#f87d83",
                      width: 25,
                      height: 25,
                      marginRight: "12px",
                    }}
                  />
                  <Typography sx={{ fontSize: "14pt" }}>
                    {el.name}
                  </Typography>
                </Box>
              ))}
            </Box>
          )}
        </Box>
      </Box>

      {/*ГРАНИЦА*/}
      <div style={{ marginTop: "10px", width: "100%" }}>
        <Divider
          orientation="horizontal"
          sx={{ borderBottomWidth: "10px", borderColor: "#e3e3e3" }}
        />
      </div>

      {/* OZON */}

      <Box sx={{ width: "100%", padding: "20px" , marginTop:'30px'}}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography sx={{ fontSize: "18pt", color: "#838383" }}>
            ID клиента API OZON:
          </Typography>
          <img src={ozone} style={{ width: 60, height: 60 }} />
        </Box>

        <TextField
          style={{ width: "100%", marginTop: "10px" }}
          value={user.api_cli_ozon}
          onChange={(event) => change("api_cli_ozon", event.target.value)}
        />

        <Typography sx={{ marginTop: "15px", color: "#838383", fontSize: "18pt"}}>
          Ключ API OZON:
        </Typography>

        <TextField
          style={{ width: "100%", marginTop: "10px" }}
          value={user.api_key_ozon || ""}
          placeholder={!user.api_key ? "Не указано" : ""}
          onChange={(event) => change("api_key_ozon", event.target.value)}
          type={showPassword ? "text" : "password"}
          InputProps={{
            endAdornment: (
              <IconButton
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            ),
          }}
        />
        <Box sx={{ marginTop: "15px" }}>
          {loadingOZON ? (
            <Loading />
          ) : (
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "8px 20px",
              }}
            >
              {OZONCheck.map((el, i) => (
                <Box key={i} display="flex" alignItems="center">
                  <CheckCircleOutlineIcon
                    sx={{
                      color: el.active ? "#208f84" : "#f87d83",
                      width: 25,
                      height: 25,
                      marginRight: "6px",
                    }}
                  />
                  <Typography sx={{ fontSize: "14pt" }}>
                    {el.name}
                  </Typography>
                </Box>
              ))}
            </Box>
          )}
        </Box>
      </Box>

      {/* КНОПКА */}

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
          marginTop: "80px",
          padding: "0 20px 20px 20px",
        }}
      >
        {changed && (
          <Button
            onClick={save}
            variant="contained"
            sx={{
              textTransform: "none",
              backgroundColor: colors.elements,
              fontWeight: "bold",
            }}
          >
            Сохранить
          </Button>
        )}
      </div>
    </div>
  );
};

export default ClientAPISettings;
